import { defineStore } from 'pinia'

export const useTenantGuardStore = defineStore('tenantGuard', {
  state: () => ({
    isVerified: false,
    isModalOpen: false,
    redirectAfterSuccess: null as string | null,
  }),
  actions: {
    verify(username: string, password: string): boolean {
      if (username === 'admin' && password === 'MenuxPlus.2026') {
        this.isVerified = true
        this.isModalOpen = false
        return true
      }
      return false
    },
    openModal(redirectRouteName: string | null = null) {
      this.isModalOpen = true
      this.redirectAfterSuccess = redirectRouteName
    },
    closeModal() {
      this.isModalOpen = false
      this.redirectAfterSuccess = null
    },
    resetVerification() {
      this.isVerified = false
    },
  },
})
